import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ControlContainer,
  FormGroupDirective,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { ErrorMessageComponent } from '../../../layout/error-message/error-message.component';
import { AppendTestIdPipe } from '../../../../pipes/append-test-id/append-test-id.pipe';
import { FormTranslationInputComponent } from '../form-translation-input.component';

@Component({
  selector: 'aw-translation-text-area',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ErrorMessageComponent,
    AppendTestIdPipe,
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  templateUrl: './translation-text-area.component.html',
})
export class TranslationTextAreaComponent
  extends FormTranslationInputComponent
  implements OnInit, OnDestroy
{
  constructor(public override ngControl: NgControl) {
    super(ngControl);
  }
}
